import {IWidgetControllerConfig} from '@wix/native-components-infra/dist/src/types/types'
import {createFedopsLogger} from '../../commons/services/fedops'

export const createWidgetFedopsLogger = (controller: IWidgetControllerConfig) => {
  const config = controller.appParams.baseUrls.iframeUrl
    ? 'wix-events-widget-editor'
    : {
        appId: controller.appParams.appDefinitionId,
        widgetId: controller.type,
      }
  return createFedopsLogger(controller, config)
}
